<template>
  <article class="container-fixed offset-top-2 offset-bottom-2">
    <div id="logout" style="padding-bottom: 36px;">
      <header>
        <h1>{{ $t('common.logout_top_headline') }}</h1>
      </header>
      <div class="notification notification-positive notification notification-dismissible offset-top-2">
        <div class="notification-heading" style="text-align:center">{{ $t('common.logout_terminated_session_information') }}</div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'Logout',

  computed: {
    languages() {
      if (this.availableLanguages !== null) return this.availableLanguages;
      return Object.keys(this.$i18n.messages);
    },
  },

  created() {
    this.$webtrekk.viewPage('abmeldung', 'basket');
  },
};
</script>
